<template>
    <div class="seatsListBox">
        <avue-crud :data="data" :option="option" :page.sync='page'
                   @current-change='changePage' @size-change="sizeChange">
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="viewPeriodBtn(scope.row)">查看坐席有效期限列表</el-dropdown-item>
            </template>
        </avue-crud>
        <!--      查看坐席有效期限列表-->
        <el-dialog
            :close-on-click-modal="false"
            :destroy-on-close="true"
            :visible.sync="dialogFormVisible"
            title="查看坐席有效期限列表"
            width="70%"
        >
            <periodList v-if="dialogFormVisible" :period="period"></periodList>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">
                    关 闭
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getSeatsList } from '@/api/personal';
import periodList from '@/views/enterprise/components/periodList.vue';

export default {
    name: 'seatsList',
    components:{
        periodList
    },
    data() {
        return {
            dialogFormVisible:false,
            listArgument: {
                limit: 10,
                page: 1
            },
            // 有效期限列表
            period: {
                mobile: "",
                limit: 10,
                page: 1
            },
            page: {
                currentPage: 1,
                total: 20,  //总数
                pageSize: 10  //每页条数
            },
            data: [],
            option: {
                stripe: true,
                addBtn: false,  //新增按钮
                align: 'center',  //文本居中
                menuAlign: 'center', //操作栏居中
                columnBtn: false,  //列动态显隐按钮
                refreshBtn: false,  //刷新按钮
                editBtn: false,  //编辑按钮
                delBtn: false,  //删除按钮
                menuType: 'menu',
                menuBtnTitle: '操作',
                column: [
                    {
                        label: '坐席ID',
                        prop: 'id'
                    }, {
                        label: '坐席姓名',
                        prop: 'name'
                    }, {
                        label: '坐席手机号',
                        prop: 'mobile'
                    }, {
                        label: '累计有效期数',
                        prop: 'qishu'
                    }, {
                        label: '首次开通日期',
                        prop: 'kaitong_date'
                    }, {
                        label: '到期日期',
                        prop: 'end_date'
                    },
                ]
            }
        }
    },
    methods:{
        // 分页
        changePage(num){
            this.listArgument.page = num;
            getSeatsList(this.listArgument).then(res=>{
                this.data = res.data.list;
                this.page.total = res.data.count;
            })
        },
        // 切换每页条数
        sizeChange(val){
            this.listArgument.limit = val;
            this.listArgument.page = 1;
            this.getList();
        },
        getList(){
            getSeatsList(this.listArgument).then(res=>{
                if (res.code==200){
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                    this.page.currentPage=1
                }else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 查看坐席有效期限列表
        viewPeriodBtn(row){
            this.period.mobile = row.mobile;
            setTimeout(() => {
                this.dialogFormVisible = true;
            }, 500);
        }
    },
    created() {
        this.getList()
    }
}

</script>

<style scoped>
    .seatsListBox{
        background-color: #ffffff;
        padding: 20px;
        margin: 10px;
        border-radius: 5px;
    }
    .pull-down{
        padding: 10px 20px;
    }
    ::v-deep .avue-crud__menu{
        min-height: 0px;
    }
</style>